/* tslint:disable */
/* eslint-disable */
/**
 * Ankieter API
 * Ankieter 6.0 - the API contract, source of truth for the backend and the frontend
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * ADD_TAGS and REMOVE_TAGS take tagIds, SET_CATEGORY a categoryId, MARK_FOR_REVIEW an optional reviewReason; RETIRE and CLEAR_REVIEW nothing. A parameter the operation does not take is refused. RETIRE takes the version in force out of force; a question with only a draft has none and is skipped. MARK_FOR_REVIEW leaves a question already marked as it is.
 * @export
 * @enum {string}
 */

export const BulkOperationDto = {
    AddTags: 'ADD_TAGS',
    RemoveTags: 'REMOVE_TAGS',
    SetCategory: 'SET_CATEGORY',
    Retire: 'RETIRE',
    MarkForReview: 'MARK_FOR_REVIEW',
    ClearReview: 'CLEAR_REVIEW'
} as const;

export type BulkOperationDto = typeof BulkOperationDto[keyof typeof BulkOperationDto];



